import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
// import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Container, makeStyles, Typography, Button } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import VoucherTransfersWeb from '../components/Transfers/VoucherTransfersWeb';
import { urlVoucher } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
//import md5 from 'md5';
import { sendMobile } from '../functions/mobile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import Footer from '../components/Complements/Footer';
import { filterArrayEqual } from '../functions/arrays';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    buttonViewMovements: {
        color: '#2E2757',
        [theme.breakpoints.up('xs')]: {
            fontSize: '70%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
    },
    divStandard: {
        //margin: "20px",
        padding: "20px",
        // border: '2px solid #BEBCC0',
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    }

}));

const VoucherTransfertContainer = props => {
    const { classes, balances, parameters, user,sendEmailWithVoucher,auth,handleOpenSnack } = props
    // console.log(props)
    const monthLenght = filterArrayEqual(parameters,"code","PERIOD_MAXIMUMS_OF_MOVEMENT_OF_CONSULT")[0]

    const classes2 = useStyles()

    const [codespaginate, setCodesPaginate] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [dateStart, setDateStart] = useState(new Date(moment().startOf('month')))
    // pruebas  const [dateStart, setDateStart] = useState(new Date(moment().subtract(1, 'months').startOf('month')))
    //const [dateEnd, setDateEnd] = useState(new Date())
    const dateEnd = new Date()
    const [dateEndRange, setDateEndRange] = useState(dateEnd)
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [accountSelected, setAccountSelected] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')

            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEndRange, 1, accountSelected.PRODUCTBANKID)
        }
        return unmount()
    }

    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {

        setLoading(true)
        /*  console.log("Fecha Inicial: ", valuedateStart)
        // console.log("Fecha Final: ", valuedateEnd) */

        findTransferCore({
            $limit: 10,
            $skip: rows,
            type: {
                $in: [9, 18, 34]
            },
            state: true,
            originAccountNumber: secuencial,
            createdAt: {
                $lte: valuedateEnd,
                $gte: valuedateStart
            },
            $sort: {
                createdAt: -1
            }
        }).payload.then(
            response => {

                //console.log(response)

                const { data, total } = response

                convertJsonToData(data, total, numberpage)

                setLoading(false)
            }
        ).catch(
            error => {
                //console.log(error)
                setLoading(false)
            }
        )
    }

    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];

        data.forEach(row => {

            try {
                //console.log(row)
                let transfertjson = JSON.parse(row.dataVoucher);
                let tipo = (row.type === 9) ? 'TRANSFERENCIA A OTROS SOCIOS' :
                    (row.type === 18) ? 'TRANSFERENCIA INTERBANCARIA' :
                        'TRANSFERENCIA A MIS CUENTAS';
                (transfertjson.numeroMensajeTransaccion) && resul.push({
                    ...transfertjson,
                    fechaTransaccion: row.createdAt,
                    tipo: tipo
                });

            } catch (error) {
                //console.log(error)
            }

        })

        //console.log("TODOS LOS MOVIMIENTOS: ", resul)

        setCodesPaginate(resul)

        getDataViewTable(total, numberpage);

    }

    useEffect(mount, [])
    useEffect(() => {
    if (dateValue === 'Todos los movimientos') {
        handleGetDataMovementsBySecuencialAccount(
            0,
            dateStart,
            dateEndRange,
            1,
            accountSelected.PRODUCTBANKID
        );
    }
    }, [dateValue, dateStart, dateEndRange, accountSelected]);

    const handleDateStart = (date) => {
      setDateStart(date)

      if (dateValue === 'Todos los movimientos') {
          handleGetDataMovementsBySecuencialAccount(0, date, dateEndRange, 1, accountSelected.PRODUCTBANKID)
      }
    }

    const handleDateEnd = (date) => {
      setDateEndRange(date)

      if (dateValue === 'Todos los movimientos') {
        handleGetDataMovementsBySecuencialAccount(0, dateStart, date, 1, accountSelected.PRODUCTBANKID)
      }
    }

    const onChangePaginationCodes = (e, numberpage) => {

        handleGetDataMovementsBySecuencialAccount((numberpage - 1) * 10, dateStart, dateEnd, numberpage, accountSelected.PRODUCTBANKID);
        //setTransactionPaginate(datacodespaginate)
        //setPage(numberpage)
    }

    const handleSubmit = (val) => {
        // console.log(val)
    }


    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if (residuo > 0) {
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.PRODUCTBANKID)

    }
const handleSelectCode = (val) => {
  setDateValue(val);
  setLoading(true);

  if (val === 'Todos los movimientos') {
    const defaultStart = new Date(moment().startOf('month'));
    const defaultEnd = new Date();

    setDateStart(defaultStart);
    setDateEndRange(defaultEnd);

    handleGetDataMovementsBySecuencialAccount(
      0,
      defaultStart,
      defaultEnd,
      1,
      accountSelected.PRODUCTBANKID
    );
  } else {
    let obj = JSON.parse(val);
    // Nos aseguramos de convertir a número
    const selectedMonth = parseInt(obj.month, 10);
    const selectedYear = parseInt(obj.year, 10);
    const currentMonth = moment().month();
    const currentYear = moment().year();

    const selectMonth = new Date(selectedYear, selectedMonth, 1);
    const newStart = new Date(moment(selectMonth).startOf('month').toDate());

    let newEnd;
    if (selectedMonth === currentMonth && selectedYear === currentYear) {
      // Si el mes y año son actuales → usar hoy
      newEnd = new Date();
    } else {
      // En otros casos, usar el fin del mes seleccionado
      newEnd = new Date(moment(selectMonth).endOf('month').toDate());
    }

    setDateStart(newStart);
    setDateEndRange(newEnd);

    handleGetDataMovementsBySecuencialAccount(
      0,
      newStart,
      newEnd,
      1,
      accountSelected.PRODUCTBANKID
    );
  }
};


    const handleFindRange = () => {

        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEndRange, 1, accountSelected.PRODUCTBANKID)

    }

    const handleConvertMask = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }

    }

    const handleViewVoucher = (row) => {
        // console.log("MOVIMIENTO SELECCIONADO: ", row)
        //let documento = (row.Documento) ? row.Documento : row.documento;
        const { nombreArchivoComprobante } = row;

        const handleSendEmailWithVoucher = () => {
            setLoading(true)

            const { email } = auth;


            // console.log("Documento: ", nombreArchivoComprobante);

            //const { Monto, NumeroCuentaOrigen } = responseservertransfer;

            let object_send_email_with_voucher = {
                Documento: nombreArchivoComprobante,
                Email: email
            }

            sendEmailWithVoucher(object_send_email_with_voucher).then(
                response => {

                    const { message, type } = response.payload;


                    handleOpenSnack(message, type);
                    setLoading(false)
                }
                ).catch(
                    error => {
                    setLoading(false)
                    handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
                    }
                )
        }

        setDialog({
            open: true, title: 'Comprobante',
            children: <Container component="main" maxWidth="xl">
                <VoucherTransfersWeb
                    title={"TRANSFERENCIA EXITOSA"}
                    titleone={"DATOS EMISOR"}
                    viewVoucher={true}
                    databodyone={[
                        {
                            title: "Nombres",
                            value: row.nombreCliente ? row.nombreCliente : '',
                            order: 1
                        },
                        {
                            title: "Cuenta",
                            value: handleConvertMask(row.numeroCuentaOrigen),
                            order: 2
                        },
                        {
                            title: "Fecha",
                            value: moment(row.fecha).format("YYYY-MM-DD"),
                            order: 3
                        },
                        {
                            title: "Concepto",
                            value: row.concepto,
                            order: 4
                        },
                        {
                            title: "Dcto. de trans",
                            value: row.numeroMensajeTransaccion,
                            order: 5
                        },
                        {
                            title: "Comisión",
                            value: "$ " + row.comision,
                            order: 5
                        }
                    ]}
                    titletwo={"DATOS BENEFICIARIO"}
                    databodytwo={[
                        {
                            title: "Nombres",
                            value: row.nombreBeneficiario,
                            order: 1
                        },
                        {
                            title: "Cuenta",
                            value: handleConvertMask(row.numeroCuentaDestino),
                            order: 2
                        },
                        {
                            title: "Institución",
                            value: row.institucion,
                            order: 3
                        },
                    ]}
                    nombreCliente={row.nombreCliente}
                    numeroCuentaOrigen={handleMaskNumberAccount(row.numeroCuentaOrigen)}
                    tipoCuentaOrigen={row.tipoCuentaOrigen}
                    nombreBeneficiario={row.nombreBeneficiario}
                    numeroCuentaDestino={handleMaskNumberAccount(row.numeroCuentaDestino)}
                    tipoCuentaDestino={row.tipoCuentaDestino}
                    institucion={row.institucion}
                    monto={row.monto}
                    comision={row.comision}
                    concepto={row.concepto}
                    fecha={row.fecha}
                    dispositivo={row.dispositivo}
                    typesizegrid={6}
                    handleDownloadVoucher={() => {
                        let namefile = row.nombreArchivoComprobante
                        window.open(urlVoucher + namefile + ".pdf", '_blank');
                    }}
                    handleDownloadDevice={() => {
                        try {
                            let namefile = row.nombreArchivoComprobante
                            let send = {
                                type: 'action',
                                action: 'export_voucher',
                                data: urlVoucher + namefile + ".pdf",
                                nameFile: namefile,
                                extension: 'pdf',
                                messageSend: 'Transferencia'
                            }
                            sendMobile(JSON.stringify(send))
                        } catch (error) {
                            //console.log(error)
                        }
                    }}
                    handleSendEmailWithVoucher={handleSendEmailWithVoucher}
                />
            </Container>
        })

    }
    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table>
                            <Thead>
                                <Tr >
                                    <Th>Fecha</Th>
                                    <Th>Tipo</Th>
                                    <Th>Concepto</Th>
                                    <Th>Beneficiario</Th>
                                    <Th>Institución</Th>
                                    <Th className={"colunmvalue"}>Monto</Th>
                                    <Th>Comprobante</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    codespaginate.map(row => (
                                        <Tr key={`${row.numeroMensajeTransaccion}`}>
                                            <Td>{moment(row.fechaTransaccion).format("YYYY-MM-DD HH:mm:ss")}</Td>
                                            <Td>{row.tipo}</Td>
                                            <Td>{row.concepto}</Td>
                                            <Td>{row.nombreBeneficiario} # {handleMaskNumberAccount(row.numeroCuentaDestino)}</Td>
                                            <Td>{row.institucion}</Td>
                                            <Td>$ {row.monto}</Td>
                                            <Td>
                                                <Button variant='contained' aria-label="delete" onClick={() => handleViewVoucher(row)}>
                                                    <Typography className={classes2.buttonViewMovements} align="left">
                                                        VER
                                                    </Typography>
                                                </Button>
                                                {/* <IconButton edge="end" aria-label="delete" onClick={() => handleViewVoucher(row)}>
                                                    <Typography className={classes2.buttonViewMovements} align="left">
                                                        VER
                                                    </Typography>
                                                </IconButton> */}
                                            </Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                        <Pagination
                            style={{ marginTop: '5px' }}
                            count={count}
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return <div className={classes2.divStandard}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Typography>Detalle de movimientos de la Cuenta</Typography>
                </Grid>
                {/* <Grid item xs={12} md={4} lg={4} sm={12}>

                </Grid> */}
            </Grid>
            <SelectForm
                name={'Periodo'}
                label={'Seleccione periodo '}
                parameters={parameters}
                classes={classes}
                dateValue={dateValue}
                onSelected={(val) => handleSelectCode(val)}
                onSubmit={handleSubmit}
            ></SelectForm>
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                    minDate={moment().subtract("M",monthLenght.value)}
                                    maxDate={dateEndRange}
                                    maxDateMessage="La fecha de inicio no debe ser superior a la fecha de fin"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEndRange}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                    maxDate={new Date()}
                                    maxDateMessage="La fecha de fin no debe ser superior a la fecha actual"
                                    minDate={dateStart}
                                    minDateMessage="La fecha de fin no debe ser anterior a la fecha inicio"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: '#b48518' }} aria-label="add" onClick={handleFindRange} >
                                <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                            </Fab>
                            {/* <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CONSULTAR
                            </Typography> */}
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: 'red' }} aria-label="add" onClick={() => history.push('/')} >
                                <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                            </Fab>
                            {/* <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CANCELAR
                            </Typography> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br /> <br />
            <Grid container spacing={3} justifyContent="center" alignItems="center" m={30}>
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }

    const handleMaskNumberAccount = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }
    }

    const renderHeader = () => {
        return <div className={classes2.divStandard}>
            <Grid container>
                <Typography>Transferencias Realizadas</Typography>
                <FormControl variant="outlined" style={{ minWidth: '100%', marginTop: 16 }}>
                    <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                    <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={balances[0]}
                        onChange={(e) => handleAccountFind(e.target.value)}
                    >
                        {
                            balances.map(option => {
                                return <MenuItem key={option.PRODUCTBANKID} value={option}>{`${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>
        </div>
    }
    return (
        <div>
            <Grid xs={12} style={{padding:"20px 40px 0"}} >
                <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Comprobantes</Typography>
            </Grid>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={true}
                panel={2}
            />
            <Footer />
            <LoadingScreen open={loading} />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
        </div>
    );
};

VoucherTransfertContainer.propTypes = {
    balances: PropTypes.array.isRequired,
};

export default connect(null, { getCodes, sendEmailWithVoucher, findTransferCore })(VoucherTransfertContainer);

//export default VoucherTransfertContainer;
